import { FC, useState } from "react";
import cx from "classnames";
import "styles/drawer.scss";
import { DrawerProps } from "types/atoms.types";
import * as Icons from 'constants/icons';

const Drawer: FC<DrawerProps> = ({ title, children, onClick, isBackLink, isSearchClicked }) => {
  const [toggle, setToggle] = useState(true);
  const listClass = cx("asr-drawer", { "toggle-active": !toggle });
  const toggleClass = cx("toggle", { active: !toggle });
  return (
    <div className={listClass}>
      <div className={toggleClass} onClick={() => setToggle(!toggle)}>
        <img src={Icons.toggleArrow} alt="Toggle" />
      </div>
      {isBackLink && isSearchClicked && (
        <div className="asr_back_btn">
          <img src={Icons.arrowBack} alt="Arrow Back" />
          <span onClick={onClick}>Back</span>
        </div>
      )}
      <h2 className="title" onClick={() => setToggle(!toggle)}>
        {title}
      </h2>
      {children}
    </div>
  );
};

export default Drawer;
